let f = null;
function g(l) {
  f = l;
}
function d(l, e) {
  if (f)
    try {
      f(e instanceof Error ? e : new Error(String(e)), {
        ...l,
        _cms_block: !0
      });
    } catch (i) {
      console.error("[CMS] Failed to report block error:", i);
    }
}
const u = (l) => l.split("/")[0], s = (l) => l.split("/")[1];
function B(l) {
  function e(r) {
    if (!r)
      return null;
    const o = l.find(
      ([n, t]) => n === r || t === r
    );
    return o ? {
      block_name: o[0],
      module: u(o[1]),
      remote_module: o[1]
    } : null;
  }
  function i(r) {
    const o = l.filter(
      ([, t]) => r.includes(`${u(t)}/`)
    );
    if (o.length === 0)
      return null;
    const n = o.slice().sort((t, c) => s(c[1]).length - s(t[1]).length).find(
      ([, t]) => r.includes(s(t))
    );
    return n ? {
      block_name: n[0],
      module: u(n[1]),
      remote_module: n[1]
    } : { module: u(o[0][1]) };
  }
  function p(r, o, n) {
    const t = e(o) ?? e(r) ?? (o ? {
      block_name: r,
      module: u(o),
      remote_module: o
    } : null);
    t && d(t, n);
  }
  function E(r) {
    const o = e(r) ?? {
      module: u(r),
      remote_module: r
    };
    return ({ error: n }) => (console.error(
      `[Frontier] Remote module "${r}" failed to load:`,
      n
    ), d(o, n), { default: () => null });
  }
  function h(r, o) {
    var m, a, k, _, b;
    if ((r == null ? void 0 : r.type) !== "error" || (m = r.context) != null && m._cms_block)
      return;
    const n = o == null ? void 0 : o.error, t = [
      (a = r.error) == null ? void 0 : a.stack,
      (k = r.error) == null ? void 0 : k.message,
      (b = (_ = r.error) == null ? void 0 : _.resource) == null ? void 0 : b.url,
      n == null ? void 0 : n.stack
    ].filter(Boolean).join(`
`);
    if (!t)
      return;
    const c = i(t);
    c && (r.context = { ...r.context, ...c });
  }
  return {
    resolveBlockAttribution: e,
    reportBlockError: p,
    makeRemoteErrorHandler: E,
    enrichRumEvent: h
  };
}
export {
  B as createBlockErrorReporter,
  g as setBlockErrorSink
};
